import { render, staticRenderFns } from "./KnittingAndRawFabricForm.vue?vue&type=template&id=4d0ab68a&scoped=true&"
import script from "./KnittingAndRawFabricForm.vue?vue&type=script&lang=js&"
export * from "./KnittingAndRawFabricForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d0ab68a",
  null
  
)

export default component.exports